import { asISODate } from 'lib/helpers/asISODate/asISODate'
import { getPacificToday } from 'lib/helpers/getPacificToday/getPacificToday'

export const dates = {
  previous: asISODate('2025-01-20'),
  latest: asISODate('2026-03-19'),
} as const

export const getCurrentTosEffectiveDate = (): ISODate =>
  getPacificToday() >= dates.latest ? dates.latest : dates.previous
